import o from "./typeof.mjs";
function f(r, e) {
  if (o(r) !== "object" || r === null)
    return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(r, e || "default");
    if (o(i) !== "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
export {
  f as default
};
//# sourceMappingURL=toPrimitive.mjs.map
